import { Component, input, output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Persona } from '@app/v2/personas/types/persona.type'
import { ScaleBadgeDirective } from '@app/v2/shared/directives/scale-badge.directive'
import { BasicInputMode } from '@app/v2/shared/enums/input-modes.enum'
import { SafeDomPipe } from '@app/v2/shared/pipes/safe-dom.pipe'
import { DropdownComponent } from '../dropdown/dropdown.component'
import { DropdownOption } from '../dropdown/types/dropdown-option.type'
import { BasicInputComponent } from '../inputs/basic-input/basic-input.component'

@Component({
  selector: 'app-mobile-persona-card',
  imports: [BasicInputComponent, DropdownComponent, SafeDomPipe, ScaleBadgeDirective],
  templateUrl: './mobile-persona-card.component.html',
  styleUrl: './mobile-persona-card.component.scss'
})
export class MobilePersonaCardComponent {
  public persona = input.required<Persona>()
  public personaNameControl = input.required<FormControl<string>>()
  public personaMenuOptions = input.required<DropdownOption[]>()
  public menuDropdownHeight = input.required<number>()
  public basicInputMode = input.required<typeof BasicInputMode>()
  public readonly readonly = input(false)
  public readonly personaNameBlur = output<void>()
  public readonly personaNameKeydown = output<KeyboardEvent>()
  public readonly personaMenuOption = output<DropdownOption>()
  public readonly landingPageClick = output<Event>()
  public readonly manageClick = output<Event>()

  /**
   * Reverts blank inline edits to the saved persona name.
   */
  public handlePersonaNameBlur(): void {
    const trimmedValue = String(this.personaNameControl().value ?? '').trim()
    if (!trimmedValue) {
      this.personaNameControl().setValue(this.persona().name ?? '', { emitEvent: false })
      return
    }
    this.personaNameBlur.emit()
  }

  /**
   * Enter follows the same blur-driven flow as desktop.
   * Other keys are forwarded unchanged.
   */
  public handlePersonaNameKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter') {
      this.personaNameKeydown.emit(event)
      return
    }

    event.preventDefault()
    ;(event.target as HTMLElement)?.blur()
  }

  /**
   * Handles manage click.
   * @param event {Event} - The event object.
   */
  public onManageClick(event: Event): void {
    if (this.readonly()) return
    this.manageClick.emit(event)
  }

  /**
   * Handles landing page click.
   * @param event {Event} - The event object.
   */
  public onLandingPageClick(event: Event): void {
    if (this.readonly()) return
    this.landingPageClick.emit(event)
  }
}
